import { apiClient } from '@/shared/api';
import {
  handleRequest,
  type RequestHandlerOptions,
} from '@/shared/api/apiWrapper';
import type { SavedCardsResponse } from '../model';

const getSavedCards = async (options?: RequestHandlerOptions) => {
  const request = () => apiClient.get(`/operations/card/template`);
  const response = await handleRequest<SavedCardsResponse>(request, options);
  return response.data;
};

export { getSavedCards };
